var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalesforce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.05 4.85c.87-.91 2.08-1.48 3.42-1.48 1.64 0 3.08.85 3.92 2.13a5.04 5.04 0 0 1 2.11-.46c2.76 0 5 2.2 5 4.92s-2.24 4.92-5 4.92c-.38 0-.75-.04-1.1-.13a3.98 3.98 0 0 1-3.54 2.16c-.6 0-1.17-.13-1.68-.37A4.46 4.46 0 0 1 9 19.37a4.46 4.46 0 0 1-4.18-2.83 4.3 4.3 0 0 1-.82.08c-2.21 0-4-1.93-4-4.31s1.79-4.31 4-4.31c.72 0 1.4.2 1.98.55a4.58 4.58 0 0 1 4.07-2.7z",
    fill: "#00A1E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesforce);
export default __webpack_public_path__ + "static/media/salesforce.b5854be0b82c33bc4491a9840eef1883.svg";
export { ForwardRef as ReactComponent };